import styled from "styled-components";

export const VerticalSliderWrapper = styled.input`
  width: 40px;
  height: 130px;
  background-color: black;
  -webkit-appearance: none;
  appearance: none;
  cursor: grab;
  position: relative;

  &::-webkit-slider-runnable-track {
    width: 10px;
    height: 80%;
    background: linear-gradient(to top, #f1f1f1 0%, #f1f1f1 100%);
    border-radius: 50px;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
  }

  &::-moz-range-track {
    width: 7px;
    height: 90%;
    background: linear-gradient(to top, #f1f1f1b 0%, #f1f1f1 100%);
    border-radius: 50px;
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    background-color: #d3d3d3;
    border-radius: 50%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    background-color: #d3d3d3;
    border-radius: 50%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }

  &:hover::-webkit-slider-thumb,
  &:active::-webkit-slider-thumb {
    background-color: #d3d3d3;
  }

  &:hover::-moz-range-thumb,
  &:active::-moz-range-thumb {
    background-color: #d3d3d3;
  }

  writing-mode: vertical-lr;
  transform: rotate(180deg);
`;
